export default "__VITE_ASSET__Dqrw_0Qq__"